import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import {format as formatDate, isDate} from "date-fns";
import itLocale from "date-fns/locale/it";
import enLocale from "date-fns/locale/en-GB";
import deLocale from "date-fns/locale/de";
import axios from 'axios';

const SUPPORTED_LANGUAGES = {
    it: "Italiano",
    en: "English",
    de: "Deutsch",
}

/*
 * locales for calendar
 */
const dateFnsLocales = {
    it: itLocale,
    en: enLocale,
    de: deLocale,
};

const getDateFnsLocale = (language) => {
    return dateFnsLocales.hasOwnProperty(language) ? dateFnsLocales[language] : enLocale;
}


const savedLanguage = localStorage.getItem('i18nextLng') || 'it';

// Configure axios default language
axios.defaults.headers.common['Accept-Language'] = savedLanguage;

/*
 * Initialize i18n
 */
i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: savedLanguage,
        fallbackLng: 'it',
        supportedLngs: Object.keys(SUPPORTED_LANGUAGES),
        //debug: process.env.NODE_ENV === "development",
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            format: function (value, format, lng) {
                if (isDate(value)) {
                    const locale = getDateFnsLocale(lng);
                    return formatDate(value, format, {locale: locale});
                }
                return value;
            }
        },
        ns: ['translation', 'validation', 'enums', 'auth', 'components', 'layouts', 'inputs',
        'users', 'user', 'stations', 'groups', 'dashboard', 'acl', 'workgroups', "models1",
        'models23', 'importTasks', 'exportTasks', 'graphs', 'incidents', 'models4', 'analytics',
        'webgis', 'errors'],
    });

i18n.on('languageChanged', (lng) => {
    axios.defaults.headers.common['Accept-Language'] = lng;
});

export {getDateFnsLocale, SUPPORTED_LANGUAGES}